<template>
  <div id="app">
    <header>
      <BannerBox />
    </header>
    <main id="pageContents">
      <RouterView />
    </main>
    <footer>
      <SecondaryNav />
    </footer>
  </div>
</template>

<script>
import BannerBox from "@/components/BannerBox.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";

export default {
  name: "App",
  components: { SecondaryNav, BannerBox },
};
</script>

<style lang="scss">
@use "@/assets/styles/livery" as *;

body {
  color: $colour-body-text;
  background-color: $colour-page-background !important;
  background-image: url("/src/assets/scssAssets/paper.webp");
  background-repeat: repeat;
  margin: 0; // prevent spacing appearing above and at sides of the banner box

  #app {
    font-family: "Times New Roman", Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    text-align: center;

    h1,
    h2,
    h3,
    h4 {
      font-family: branded-font, "Times New Roman", Times, serif;
      text-align: center;
    }

    nav a {
      padding: 0.5em;
    }

    #pageContents {
      // this always ensures that the secondary margin does not obscure the tail of the page
      margin-bottom: 10em;

      a {
        color: $colour-body-text;
      }

      img,
      iframe,
      audio,
      video {
        border-radius: 5px;
        box-shadow: 5px 5px 10px $colour-body-text-shadow;
      }
    }
  }
}
</style>
